let $workshopList;

export const init = () => {

  $workshopList = $('.workshop-sports__list');

  cube.event.on('resize-width', cube.debounce(resizeHandler, 100));

  resizeHandler();

};

export const initLegacy = () => {

  $('.workshop-template')

    .on('click', '.workshop-detail-link', (e) => {
      $(e.currentTarget).closest('tr').nextAll('.toggle-row').first().slideToggle();
    })

    .on('click', '.panel-menu-bar', (e) => {
      $(e.currentTarget).toggleClass('opened');
      $('#menuNav').stop().slideToggle('fast');
    })

    .on('click', '.has-dropdown', (e) => {
      const self = $(e.currentTarget);
      self.toggleClass('active').next('.list-dropdown').stop().slideToggle('fast');
      self.children('span').first().toggleClass('icon-plus icon-minus');
    });

};


const resizeHandler = () => {

  $workshopList.on('init', (event, slick) => {
    if (!cube.ui.isMobile()) checkSlickNoSlide(slick);
  });

  $workshopList.not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    responsive: [{
      breakpoint: cube.constants.breakpointMd,
      settings: { slidesToShow: 4 }
    },
    {
      breakpoint: cube.constants.breakpointSm,
      settings: 'unslick'
    }]
  });

};

const checkSlickNoSlide = (slick) => {
  if (slick.slideCount <= slick.options.slidesToShow)
    $workshopList.addClass('slick-no-slide');
  else
    $workshopList.removeClass('slick-no-slide');
};



// WEBPACK FOOTER //
// ./src/workshop/workshop-home.js